import React from "react";
import PolicyPageLayout from "../components/PolicyPageLayout";

const sections = [
  {
    title: "1. Acceptance of Terms",
    body: [
      "By using the Zea Mays Foods website or placing an order, you agree to these terms and conditions.",
      "If you do not agree with these terms, please do not use the website or place an order.",
    ],
  },
  {
    title: "2. Order Placement and Accuracy",
    body: [
      "You agree to provide accurate and complete information when ordering, including your name, contact details, delivery address, and payment information.",
      "Orders may only be placed by users who are old enough to legally enter into a purchase agreement or who have parental consent where required.",
    ],
    items: [
      "Accurate personal details",
      "Correct delivery address",
      "Valid payment information",
      "Responsibility for reviewing the final order",
    ],
  },
  {
    title: "3. Product Availability and Pricing",
    body: [
      "All products are subject to availability and prices may change without notice.",
      "The final amount payable is shown at checkout before you complete payment.",
    ],
  },
  {
    title: "4. Cancellation, Delivery, and Limitations",
    body: [
      "Once an order has been placed, changes or cancellations may not always be possible, especially after processing has started.",
      "Delivery times are estimates and can be affected by traffic, weather, or other events outside our control.",
    ],
    items: [
      "No guarantee of exact delivery timing",
      "Incorrect addresses may cause delays",
      "Perishable items require prompt receipt",
    ],
  },
  {
    title: "5. Intellectual Property and Updates",
    body: [
      "All website content, branding, and product materials remain the property of Zea Mays Foods unless stated otherwise.",
      "We may update these terms from time to time. Continued use of the website means you accept the latest version.",
    ],
  },
];

const TermsConditionsPage = () => {
  return (
    <PolicyPageLayout
      title="Terms & Conditions"
      intro="These terms govern your use of the Zea Mays Foods website and the purchase of our products through the online store."
      sections={sections}
      contactEmail="zeamaysfood@gmail.com"
      contactPhone="+2347037038448"
      lastUpdated="July 14, 2026"
    />
  );
};

export default TermsConditionsPage;
